<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <!-- <img class="h-7 w-7 rounded-full" [src]="user.avatar" /> -->
            <avatar
                [src]="user.avatar"
                [name]="user.name"
                containerClass="size-7 rounded-full"
                elementClass="text-xs object-cover min-h-full minw-full"
            />
        }
        @if (!showAvatar || !user.avatar) {
            <!-- <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
            <avatar
                [src]="null"
                [name]="user.name"
                containerClass="size-7 rounded-full"
                elementClass="text-xs object-cover min-h-full minw-full"
            />
        }
        <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full bg-green-500"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar,
            }"
        ></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div class="px-4 py-2">
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </div>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="['/settings']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
